import { sendRequest } from './index';
import { API_COVERLETTER_URL } from '@core/constants/API';

export const coverLetterService = {
    PUT: ({ id, ...payload }) =>
        sendRequest({
            url: `${API_COVERLETTER_URL}${id}`,
            method: 'PUT',
            body: { ...payload }
        }),
    POST: (payload) =>
        sendRequest({
            url: `${API_COVERLETTER_URL}`,
            method: 'POST',
            body: payload
        }),
    DELETE: (id) =>
        sendRequest({
            url: `${API_COVERLETTER_URL}${id}`,
            method: 'DELETE'
        }),
    GET: (id) => {
        return sendRequest({
            url: `${API_COVERLETTER_URL}${id}`,
            method: 'GET'
        });
    }
};

export const coverLetterMetaData = () => {
    return sendRequest({
        url: `${API_COVERLETTER_URL}`,
        method: 'GET',
    });
}

export const exportCoverLetter = (payload) => {
    return sendRequest({
        url: `${API_COVERLETTER_URL}${payload.id}/exports`,
        method: 'POST',
        // responseType: 'arraybuffer',
        body: payload
    });
};

export const exportCoverLetterPDF = (id) => {
    return sendRequest({
        url: `${API_COVERLETTER_URL}${id}/exports`,
        method: 'GET',
        responseType: 'arraybuffer',
    });
};


export const coverLetterAll = {
    GET: (queryParams) => {
        return sendRequest({
            url: `${API_COVERLETTER_URL}${queryParams}`,
            method: 'GET'
        });
    }
};